import request from '@/utils/request';

// 货币
export function currencyList(data) {
  return request.post('admin/currency/list', data);
}
export function currencyDetail(data) {
  return request.post('admin/currency/detail', data);
}
export function currencyStore(data) {
  return request.post('admin/currency/store', data);
}
export function currencyEdit(data) {
  return request.post('admin/currency/edit', data);
}
export function currencyResource(data) {
  return request.post('admin/currency/resource', data);
}

// 国家
export function countryList(data) {
  return request.post('admin/country/list', data);
}
export function countryDetail(data) {
  return request.post('admin/country/detail', data);
}
export function countryStore(data) {
  return request.post('admin/country/store', data);
}
export function countryEdit(data) {
  return request.post('admin/country/edit', data);
}